/**
 * Check if the input value is undefined or null
 *
 * @param input
 * @return {boolean}
 */
export const isUndefinedOrNull = input => input === undefined || input === null;

/**
 * Check if the input value is an empty string
 *
 * @param input
 * @return {boolean}
 */
export const isEmptyString = input => typeof input === "string" && input.length === 0;

/**
 * @param array
 * @param depth
 * @return {any[]}
 */
export const flatten = (array, depth = 1) => {
    return repeat(depth, () => {
        array = [].concat.apply([], array);

        return array;
    });
};

/**
 * Repeat given callback x times also
 * passing to callback current
 * iteration number
 *
 * @param times
 * @param fn
 * @returns {any[]}
 */
export const repeat = (times, fn) =>
    Array.from({length: times}, (v, i) => i)
        .map(x => fn(x))
        .slice(-1)[0];

/**
 * @param array
 * @param path
 * @return {*}
 */
export const arrayPluck = (array, path) =>
    array.map(x => getObjectDot(path, x));


/**
 * Get object property
 *
 * @param path
 * @param object
 * @param defaultValue
 * @return {*}
 */
export const getObjectDot = (path, object, defaultValue = null) => {
    path.split(".").every(segment => {
        object = object[segment];
        return object;
    });
    return object || defaultValue;
};

export const toGermanNumberFormat = (number, part) => {
    return number.toFixed(part)
        .replace('.', ',')
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
}


export const allPreOrders    = (limitOrders, locationId = false) => {
    if (!limitOrders.length) return 0;

    const preOrders = limitOrders.filter(function (order) {
        if (locationId) {
            return order.type === 1 && order.location_menu_category.location_id === locationId;
        }

        return order.type === 1;
    })
    return preOrders.reduce(function (acc, obj) {
        return acc + obj.quantity;
    }, 0);
}
export const pickedPreOrders = (limitOrders, locationId = false) => {
    if (!limitOrders.length) return 0;

    const pickedOrders = limitOrders.filter(function (order) {
        if (locationId) {
            return order.type === 1 && order.pickedup === 1 && order.location_menu_category.location_id === locationId;
        }

        return order.type === 1 && order.pickedup === 1;
    })
    return pickedOrders.reduce(function (acc, obj) {
        return acc + obj.quantity;
    }, 0);
}

export const allVoucherOrders = (
    extraMeals,
    locationId = null,
    locationMenuCategoryId = null,
) => {
    if (!extraMeals) return 0;

    return Object.values(extraMeals)
        .flatMap(Object.values)
        .reduce((sum, item) => {
            if (locationId && item.location_id !== locationId) return sum;
            if (locationMenuCategoryId && item.location_menu_category_id !== locationMenuCategoryId) return sum;
            return sum + item.value;
        }, 0);
};

export const pickedVoucherOrders = (limitOrders, locationId = false) => {
    if (!limitOrders.length) return 0;

    const pickedVouchers = limitOrders.filter(function (order) {
        if (locationId) {
            return (order.type === 3 || order.type === 2) && order.pickedup === 1 && order.location_menu_category.location_id === locationId;
        }

        return (order.type === 3 || order.type === 2) && order.pickedup === 1;
    })
    return pickedVouchers.reduce(function (acc, obj) {
        return acc + obj.quantity;
    }, 0);
}
